import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import notificationsActions from '../../notifications/action-creators';
import taskGroupsActions from './task-groups';

const taskGroupTagsActions = {
  attachTaskGroupTag(taskGroupGuid, tagGuid) {
    return async (dispatch) => {
      dispatch(taskGroupsActions.setIsLoading('attachTaskGroupTag'));
      const data = await ApiService.post(
        `/api/v1/task-groups/${taskGroupGuid}/tags`,
        {
          tagGuid,
        },
      )
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(taskGroupsActions.setIsLoading('attachTaskGroupTag'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.attachTaskGroupTagSuccess(data));
      }
    };
  },
  attachTaskGroupTagSuccess(updated) {
    return (dispatch) => {
      dispatch(taskGroupsActions.replaceTaskGroup(updated.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group updated'));
    };
  },
  detachTaskGroupTag(taskGroupGuid, tagGuid) {
    return async (dispatch) => {
      dispatch(taskGroupsActions.setIsLoading('detachTaskGroupTag'));
      const data = await ApiService.delete(`/api/v1/task-groups/${taskGroupGuid}/tags/${tagGuid}`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(taskGroupsActions.setIsLoading('detachTaskGroupTag'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.detachTaskGroupTagSuccess(data));
      }
    };
  },
  detachTaskGroupTagSuccess(updated) {
    return (dispatch) => {
      dispatch(taskGroupsActions.replaceTaskGroup(updated.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group updated'));
    };
  },
};

export default taskGroupTagsActions;
